import ApplyConfigPatternFormProvider from "../components/apply-config-pattern-form-provider";
import FirmwareUpdateFormProvider from "../components/firmware-update-form-provider";

ManageIQ.component.addReact("ApplyConfigPatternFormProvider", ApplyConfigPatternFormProvider);
ManageIQ.component.addReact("FirmwareUpdateFormProvider", FirmwareUpdateFormProvider);